import { PagedSearch } from 'src/app/shared/model/paged-search.model';

export class TaskSearchDto extends PagedSearch {
  AssignedToUserNum: number;
  ProfileId: number;
  AssignedByOrToUserNum: number;
  TitleOrNoteKeywords: string;
  DueDateRangeStart: Date;
  DueDateRangeEnd: Date;
  Complete: boolean;
  IncludeProfile = false;

  constructor(profileId = 0, assignedToUserNum = 0) {
    super();
    this.AssignedToUserNum = assignedToUserNum;
    this.ProfileId = profileId;
  }
}
